import clsx from 'clsx';
import React from 'react';
import { polymorphicFactory } from '../../factory/factory.utils.mjs';
import { Flex } from '../Flex/Flex.mjs';
import classes from './AspectRatioKeeper.module.css.mjs';
import { aspectRatioKeeperClasses } from './AspectRatioKeeper.utils.mjs';

const AspectRatioKeeper = polymorphicFactory(
  (props, ref) => {
    const { component = "figure", className, aspectRatio, style, ...rest } = props;
    const ar = aspectRatio ? aspectRatioKeeperClasses[aspectRatio] : void 0;
    const classNames = clsx("kohler-aspect-ratio-keeper-root", className, classes.root);
    return /* @__PURE__ */ React.createElement(
      Flex,
      {
        className: classNames,
        component,
        ref,
        style: ar ? { ...style, ["--ar"]: ar } : style,
        ...rest
      }
    );
  }
);

export { AspectRatioKeeper };
